import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { currentUserSelector } from '/src/views/Auth/Login/selector';
import "./FeaturesModal.scss";
import Orgs from '/src/views/Orgs/Orgs';
import OrgFeatureItemDetail from '/src/views/Orgs/OrgItemDetail/OrgFeatureItemDetail';
import { useRouteMatch, Route } from "react-router-dom";
import { Modal, Spin } from 'antd';
import { orgLoadingSelector } from '/src/views/Orgs/selector';
import { useTranslate } from '/src/lib/MrTranslate/MrTranslate';

const FeaturesModal = (props) => {
  const currentUser = useSelector(currentUserSelector())
  const { path } = useRouteMatch();  
  const mrIntl = useTranslate();
  const orgLoading = useSelector(orgLoadingSelector())

  console.log("orgFeatureLoading => ", orgLoading)

  // if (!(import.meta.env.VITE_MODE === "development" && currentUser?.role === 'admin')) {
  //   return null;
  // }

  const [isVisible, setIsVisible] = useState(false);
  // const [isLoading, setIsLoading] = useState(false);

  const handleKeyboardShortcuts = useCallback((e) => {
    console.log("handleKeyboardShortcuts => ", e)
    if ((e.altKey || e.metaKey) && e.shiftKey && e.keyCode === 75) {
      e.preventDefault();
      setIsVisible(true);
    }
  }, []);

  useEffect(() => {
    document.addEventListener("keydown", handleKeyboardShortcuts);
    return () => {
      document.removeEventListener("keydown", handleKeyboardShortcuts);
    }
  }, [handleKeyboardShortcuts])

  return (
    isVisible ? 
    <Modal
      className="features-modal"
      open={isVisible}
      onCancel={() => setIsVisible(false)}
      footer={null}
      width={"50%"}
      title={mrIntl("CommonText.feature_overrides")}
    > 
      <Spin 
        spinning={orgLoading} 
        className='org-features-modal-loading'
      >
        <Route
          path={`${path}`}
          render={(routeProps) => (
            <Orgs
              resourceId={currentUser.org_id}
              embedded={false}          
              isRoute={false}
              {...routeProps}
              config={{
                routes: { fetch: false},
                itemDetail: { widget: (props) => <OrgFeatureItemDetail {...props} setIsVisible={setIsVisible} />},
              }}
            />
          )}
        />      
      </Spin>
    </Modal>
    : null
  );
};

export default FeaturesModal;